"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var rule_constants_1 = require("./rule-constants");
var _1 = require(".");
exports.defaultValues = {
    type: rule_constants_1.conditionTypes.operator,
    operator: rule_constants_1.operationTypes.And,
    conditionList: immutable_1.List([]),
};
/** Factory that generates a [[IOperationConditionRecord]] */
exports.OperationConditionRecord = immutable_1.Record(exports.defaultValues);
/** immutable representation of an [[IOperationCondition]] */
var ImmutableOperationCondition = /** @class */ (function (_super) {
    __extends(ImmutableOperationCondition, _super);
    function ImmutableOperationCondition(props) {
        var _this = _super.call(this, __assign({}, props, { conditionList: immutable_1.List(!!props.conditions ? props.conditions.map(function (condition) { return _1.convertConditionToImmutable(condition); }) : []) })) || this;
        _this.conditions = _this.conditionList.toArray();
        return _this;
    }
    /**
     * creates a clone of the current [[ImmutableOperationCondition]]
     * @param key property to change
     * @param value value that the property will be set to
     */
    ImmutableOperationCondition.prototype.set = function (key, value) {
        var result = _super.prototype.set.call(this, key, value);
        var object = result.toObject();
        return new ImmutableOperationCondition(object);
    };
    /** makes sure that converting this to an object includes the conditions array */
    ImmutableOperationCondition.prototype.toObject = function () {
        var object = _super.prototype.toObject.call(this);
        var immutableConditions = object.conditionList.toArray();
        return __assign({}, object, { conditions: immutableConditions.map(function (condition) { return condition.toObject(); }) });
    };
    return ImmutableOperationCondition;
}(exports.OperationConditionRecord));
exports.ImmutableOperationCondition = ImmutableOperationCondition;
//# sourceMappingURL=operation-condition.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-rules/operation-condition.js
// module id = 1109
// module chunks = 0